import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalFooter } from '@modals/core-ui/ModalFooter';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { TProps } from './types/TProps';

export const CustomConfirmationModal = ({
  onCancel,
  onSuccess,
  title = 'Confirm',
  description = 'Are you sure?',
  buttonText = 'Yes',
  isSubmitting = false,
}: TProps) => {
  return (
    <ModalWrapper width="400px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>{title}</ModalTitle>
      <p className="m-0 text-center">{description}</p>
      <ModalFooter>
        <OutlinedButton type="button" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </OutlinedButton>
        <Button type="button" onClick={onSuccess} disabled={isSubmitting}>
          {buttonText}
        </Button>
      </ModalFooter>
    </ModalWrapper>
  );
};
